import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { dateOfBirthGateGuard } from './date-of-birth-gate.guard';
import { tripAgreementsGuard } from './trip-agreements.guard';
import { groupManagementGuard } from './group-management.guard';

const requireAuth = [authGuard, dateOfBirthGateGuard];
const requireTripAccess = [...requireAuth, tripAgreementsGuard];

/**
 * Shared route fragments for trip-switch routing specs and production route tables.
 * Query-param trip switches re-run canActivate only when runGuardsAndResolvers
 * includes query params (see trip-switch-guard-rerun.spec.ts).
 */
export const groupManagementRoute = {
  path: 'group-management',
  canActivate: [...requireTripAccess, groupManagementGuard],
  runGuardsAndResolvers: 'paramsOrQueryParamsChange' as const,
} satisfies Routes[number];

/** Dashboard trip-switch spec route — loadComponent added in app.common-routes. */
export const dashboardRoute = {
  path: 'dashboard',
  canActivate: requireTripAccess,
} satisfies Routes[number];
